import { useSearchParams } from "react-router-dom";

export default function Sort() {
    const [searchParams, setSearchParams] = useSearchParams();

    const currentSort = searchParams.get('sort') || 'created_at';

    const handleSortChange = (value: string) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('sort', value);
        setSearchParams(newParams);
    };

    return (
        <div>
            <label htmlFor="sort-select">Sort by:</label>
            <select
                id="sort-select"
                value={currentSort}
                onChange={(e) => handleSortChange(e.target.value)}
            >
                <option value="created_at">Newest First</option>
                <option value="updated_at">Recently Updated</option>
                <option value="price">Price: Low to High</option>
                <option value="price_desc">Price: High to Low</option>
            </select>
        </div>
    );
}